<template>
  <vl-application-header v-if="tabNavigationItems.length > 0" v-vl-spacer:bottom.small :title="$t('app.title')" title-link="/">
    <template v-slot:tabs>
      <vl-tabs mod-no-border-bottom mobile-nav-label="Navigatie">
        <template v-slot:tabLinks>
          <vl-tab-link
            v-for="(item, index) in tabNavigationItems"
            :key="index"
            :to="item.link"
            :active="item.active"
            :mod-external="item.external"
            :mod-no-visited-state="true"
            >{{ item.name }}</vl-tab-link
          >
        </template>
      </vl-tabs>
    </template>
  </vl-application-header>
</template>

<script lang="ts" setup>
import { ref, watch, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@/store/user.store';
import { getDomainConfigurations } from '@/core/security/domain.config.ts';

const store = useUserStore();
const route = useRoute();
const router = useRouter();

const tabNavigationItems = ref([]);

const loadNavigationItems = async () => {
  const navigationItems = await Promise.all(
    getDomainConfigurations().map(async (d) => {
      const isInRole = await store.hasRolesAsync(d.roles);
      if (isInRole) {
        return {
          name: d.title,
          link: d.route,
          active: route.path.startsWith(d.route)
        };
      }
    })
  );

  return navigationItems.filter((x) => !!x);
};

const updateNavigationItems = async () => {
  tabNavigationItems.value.forEach((item) => {
    item.active = route.path.startsWith(item.link);
  });
};

watch(
  () => route.path,
  () => updateNavigationItems()
);

watchEffect(async () => {
  tabNavigationItems.value = await loadNavigationItems();
});

watch([tabNavigationItems, () => route.name], ([newItems, routeName]) => {
  // Enkel doorsturen vanaf de neutrale startpagina, anders overschrijft dit elke diepe link
  // (bv. een nieuwe tab die op /configuration/entitymodel/:id opstart) bij het (her)laden van de app.
  if (newItems.length === 1 && routeName === 'home') {
    const singleDomain = newItems[0];
    if (singleDomain && singleDomain.link) {
      router.push(singleDomain.link);
    }
  }
});
</script>

<style lang="scss" scoped>
.vl-application-header {
  padding-top: 20px;
}
</style>
